import $ from "jquery";

export default {
    apply($context) {
        const $elements = $context.find("[data-show-phone-after-click]");
        $elements.each(function() {
            const $el = $(this);
            const newText = $el.data("show-phone-after-click");
            const tel = $el.data("tel");

            $el.one("click", function() {
                $el.html("");

                $("<a class='visible-xs'></a>")
                    .attr("href", tel)
                    .text(newText)
                    .appendTo($el);

                $("<span class='hidden-xs'></span>")
                    .text(newText)
                    .appendTo($el);
            });
        });
    },
    destroy($context) {
        const $elements = $context.find("[data-show-phone-after-click]");
        $elements.off("click");
    }
};